import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";

export default function AgeVerificationModal() {
  const { user, refresh } = useAuth();
  const [dob, setDob] = useState("");
  const [loading, setLoading] = useState(false);

  const open = !!user && !user.age_verified;

  const submit = async () => {
    if (!dob) return;
    setLoading(true);
    try {
      await api.post("/profile/verify-age", { dob });
      await refresh();
      toast.success("Verified. Welcome in!");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent
        data-testid={TID.ageVerifyModal}
        className="bg-white border-2 border-[var(--text)] text-[var(--text)] rounded-3xl max-w-md"
        style={{ boxShadow: "6px 6px 0 0 var(--text)" }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="w-14 h-14 rounded-full bg-[var(--yellow)] border-2 border-[var(--text)] flex items-center justify-center mb-2" style={{ boxShadow: "3px 3px 0 0 var(--text)" }}>
            <span className="font-display text-xl">18+</span>
          </div>
          <DialogTitle className="font-display text-3xl">
            Age check
          </DialogTitle>
          <DialogDescription className="text-[var(--text-2)]">
            You must be 18 or older to browse and order. We check your DOB once — details stay
            encrypted and are never shared with drivers.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <label className="label-eyebrow">Date of birth</label>
          <Input
            data-testid={TID.ageVerifyInput}
            type="date"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            className="mt-2 bg-white border-2 border-[var(--text)] rounded-full h-11 text-[var(--text)]"
            style={{ boxShadow: "3px 3px 0 0 var(--text)" }}
          />
        </div>
        <button
          data-testid={TID.ageVerifySubmit}
          onClick={submit}
          disabled={loading || !dob}
          className="mt-6 btn-primary w-full"
        >
          {loading ? "Verifying…" : "Verify & continue"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
